import {useMemo as $jmOdw$useMemo, useEffect as $jmOdw$useEffect} from "react";
import {useMultipleSelectionState as $jmOdw$useMultipleSelectionState, SelectionManager as $jmOdw$SelectionManager} from "@react-stately/selection";
import {useCollection as $jmOdw$useCollection} from "@react-stately/collections";
import {useControlledState as $jmOdw$useControlledState} from "@react-stately/utils";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $4b9a49966c91856a$exports = {};

$parcel$export($4b9a49966c91856a$exports, "useListState", () => $4b9a49966c91856a$export$2f645645f7bca764);

var $80be09205507c5ec$exports = {};

$parcel$export($80be09205507c5ec$exports, "ListCollection", () => $80be09205507c5ec$export$d085fb9e920b5ca7);
var tmp = Symbol.iterator;
class $80be09205507c5ec$export$d085fb9e920b5ca7 {
    *[tmp]() {
        yield* this.iterable;
    }
    get size() {
        return this.keyMap.size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        return node ? node.prevKey : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        return node ? node.nextKey : null;
    }
    getFirstKey() {
        return this.firstKey;
    }
    getLastKey() {
        return this.lastKey;
    }
    getItem(key) {
        return this.keyMap.get(key);
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    constructor(nodes){
        this.keyMap = new Map();
        this.iterable = nodes;
        let visit = (node)=>{
            this.keyMap.set(node.key, node);
            if (node.childNodes && node.type === 'section') for (let child of node.childNodes)visit(child);
        };
        for (let node2 of nodes)visit(node2);
        let last;
        let index = 0;
        for (let [key, node1] of this.keyMap){
            if (last) {
                last.nextKey = key;
                node1.prevKey = last.key;
            } else {
                this.firstKey = key;
                node1.prevKey = undefined;
            }
            if (node1.type === 'item') node1.index = index++;
            last = node1;
            // Set nextKey as undefined since this might be the last node
            // If it isn't the last node, last.nextKey will properly set at start of new loop
            last.nextKey = undefined;
        }
        this.lastKey = last === null || last === void 0 ? void 0 : last.key;
    }
}




function $4b9a49966c91856a$export$2f645645f7bca764(props) {
    let { filter: filter  } = props;
    let selectionState = $jmOdw$useMultipleSelectionState(props);
    let disabledKeys = $jmOdw$useMemo(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set()
    , [
        props.disabledKeys
    ]);
    let factory = (nodes)=>filter ? new $80be09205507c5ec$export$d085fb9e920b5ca7(filter(nodes)) : new $80be09205507c5ec$export$d085fb9e920b5ca7(nodes)
    ;
    let context = $jmOdw$useMemo(()=>({
            suppressTextValueWarning: props.suppressTextValueWarning
        })
    , [
        props.suppressTextValueWarning
    ]);
    let collection = $jmOdw$useCollection(props, factory, context, [
        filter
    ]);
    // Reset focused key if that item is deleted from the collection.
    $jmOdw$useEffect(()=>{
        if (selectionState.focusedKey != null && !collection.getItem(selectionState.focusedKey)) selectionState.setFocusedKey(null);
    }, [
        collection,
        selectionState.focusedKey
    ]);
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: new $jmOdw$SelectionManager(collection, selectionState)
    };
}


var $e08e0e9da1306088$exports = {};

$parcel$export($e08e0e9da1306088$exports, "useSingleSelectListState", () => $e08e0e9da1306088$export$e7f05e985daf4b5f);



function $e08e0e9da1306088$export$e7f05e985daf4b5f(props) {
    var _defaultSelectedKey;
    let [selectedKey, setSelectedKey] = $jmOdw$useControlledState(props.selectedKey, (_defaultSelectedKey = props.defaultSelectedKey) !== null && _defaultSelectedKey !== void 0 ? _defaultSelectedKey : null, props.onSelectionChange);
    let selectedKeys = $jmOdw$useMemo(()=>selectedKey != null ? [
            selectedKey
        ] : []
    , [
        selectedKey
    ]);
    let { collection: collection , disabledKeys: disabledKeys , selectionManager: selectionManager  } = $4b9a49966c91856a$export$2f645645f7bca764({
        ...props,
        selectionMode: 'single',
        disallowEmptySelection: true,
        allowDuplicateSelectionEvents: true,
        selectedKeys: selectedKeys,
        onSelectionChange: (keys)=>{
            let key = keys.values().next().value;
            // Always fire onSelectionChange, even if the key is the same
            // as the current key (useControlledState does not).
            if (key === selectedKey && props.onSelectionChange) props.onSelectionChange(key);
            setSelectedKey(key);
        }
    });
    let selectedItem = selectedKey != null ? collection.getItem(selectedKey) : null;
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: selectionManager,
        selectedKey: selectedKey,
        setSelectedKey: setSelectedKey,
        selectedItem: selectedItem
    };
}





export {$4b9a49966c91856a$export$2f645645f7bca764 as useListState, $e08e0e9da1306088$export$e7f05e985daf4b5f as useSingleSelectListState, $80be09205507c5ec$export$d085fb9e920b5ca7 as ListCollection};
//# sourceMappingURL=module.js.map
